import React, { createContext, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export const HINDI_PAGES = ['/', '/contact', '/international-patients'];
const LangContext = createContext({ lang: 'en', setLang: () => {}, tr: (en) => en, enabled: false });

export const LangProvider = ({ children }) => {
  const [pref, setPref] = useState(() => localStorage.getItem('lang') || 'en');
  const { pathname } = useLocation();
  const enabled = HINDI_PAGES.includes(pathname);
  const lang = enabled ? pref : 'en';

  useEffect(() => { document.documentElement.lang = lang; }, [lang]);

  const setLang = (l) => { localStorage.setItem('lang', l); setPref(l); };
  const tr = (en, hi) => (lang === 'hi' && hi ? hi : en);
  return <LangContext.Provider value={{ lang, setLang, tr, enabled }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);

export const LangToggle = ({ className = '' }) => {
  const { lang, setLang, enabled } = useLang();
  if (!enabled) return null;
  return (
    <div data-testid="lang-toggle" className={`inline-flex items-center rounded-full bg-teal-50 p-1 text-sm font-semibold ${className}`}>
      {[['en', 'EN'], ['hi', 'हिंदी']].map(([k, label]) => (
        <button key={k} data-testid={`lang-toggle-${k}`} onClick={() => setLang(k)} aria-pressed={lang === k}
          className={`px-3 py-1.5 rounded-full transition-colors ${lang === k ? 'bg-teal-700 text-white' : 'text-teal-800 hover:bg-teal-100'}`}>
          {label}
        </button>
      ))}
    </div>
  );
};
